import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import Loader from '@/components/ui/loader';

export function RootLayout() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <Loader />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  );
}
